import { useTexts } from '../hooks/useTexts'

import { form } from '../formState'

export function Password() {
  const texts = useTexts()

  // the password belongs to the user being edited, not to the logged in admin
  const username = form.useFormField('username').field.value

  const validationSummaryItems = form.useStandardPasswordValidations('new-password', { username })

  return (
    <form.Fieldset>
      <form.Password
        name="new-password"
        testId="new-password"
        label={texts.labels.password}
        placeholder={texts.placeholders.password}
        validateOn="blur change"
        errorVisibility="accent-only"
        textfieldProps={{
          autoComplete: 'new-password',
        }}
      />

      <form.ValidationSummary items={validationSummaryItems} mode="show-errors" />
    </form.Fieldset>
  )
}
